<template>
  <div class="articlemanagement">

    <Card :bordered="false">
      <div slot="title">
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="2">
          <Divider orientation="left">{{langMap.robotList[this.lang]}}</Divider>
          </Col>
          <Col :xs="24" :sm="24" :md="24" :lg="22">
          <Form :label-width="110">
            <div class="des-cardTittle-box">
              <FormItem :label="langMap.serialNumber[this.lang]" class="leftFlex">
                <Input v-model.trim="code" :placeholder="langMap.serialNumber[this.lang]" clearable />
              </FormItem>
              <FormItem :label="langMap.name[this.lang]" class="leftFlex">
                <Input v-model.trim="name" :placeholder="langMap.name[this.lang]" clearable />
              </FormItem>
              <FormItem :label="langMap.modelNumber[this.lang]" class="leftFlex">
                <Input v-model.trim="type" :placeholder="langMap.modelNumber[this.lang]" clearable />
              </FormItem>
              <FormItem :label="langMap.belongStation[this.lang]" class="leftFlex">
                <Select v-model="queryStationId" clearable>
                  <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                </Select>
              </FormItem>
              <Button type="info" style="margin-left:20px;" @click="searchData">{{langMap.search[this.lang]}}</Button>
              <Button type="primary" style="margin-left:20px;" @click="modelShow(true, null)">{{langMap.add[this.lang]}}</Button>
            </div>
          </Form>
          </Col>
        </Row>
      </div>
      <Table :height="height" :loading="tableLoading" border :columns="col" :data="robotList"></Table>
      <!--分页数据-->
      <div style="text-align:center;padding-top:10px;" v-if="robotList.length > 0">
        <Page :current="index" :total="total" :page-size="15" @on-change="goPageData"></Page>
      </div>
    </Card>

    <Modal :mask-closable="false" v-model="saveModal" :title="langMap.robotInfo[this.lang]">
      <Form ref="formValidate" :model="saveForm" :rules="ruleValidate" :label-width="80">
        <FormItem :label="langMap.productId[this.lang]" prop="productId">
          <Input v-model="saveForm.productId" :placeholder="langMap.pleaseInputProductId[this.lang]" 
                 :disabled="!!saveForm.id" />
        </FormItem>
        <FormItem :label="langMap.serialNumber[this.lang]" prop="code">
          <Input v-model="saveForm.code" :placeholder="langMap.pleaseInputSerialNumber[this.lang]" 
                 :disabled="!!saveForm.id" />
        </FormItem>
        <FormItem :label="langMap.name[this.lang]" prop="name">
          <Input v-model="saveForm.name" :placeholder="langMap.pleaseInputName[this.lang]" />
        </FormItem>
        <!--NEW ADD-->
        <FormItem :label="langMap.belongStation[this.lang]" prop="stationId">
          <Select v-model="saveForm.stationId">
            <Option v-for="item in stationList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="langMap.modelNumber[this.lang]">
          <Input v-model="saveForm.type" :placeholder="langMap.modelNumber[this.lang]" />
        </FormItem>
        <FormItem :label="langMap.description[this.lang]">
          <Input v-model="saveForm.description" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }"
            :placeholder="langMap.robotDesc[this.lang]" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" :loading="btnLoading" @click="cancel">{{langMap.cancel[this.lang]}}</Button>
        <Button type="primary" :loading="btnLoading" @click="ok">{{langMap.save[this.lang]}}</Button>
      </div>
    </Modal>

    <Modal width="50%" v-model="modal1" :title="langMap.keyInfo[this.lang]" @on-ok="modal1 = false" @on-cancel="modal1 = false">
      <p>{{langMap.publicKey[this.lang]}}：{{ puKey }}</p>
      <p>{{langMap.privateKey[this.lang]}}：{{ prKey }}</p>
    </Modal>

    <Modal
      v-model="deviceParamsModal"
      class-name="device-params-modal-wrap"
      width="960"
      :mask-closable="true"
      :title="langMap.deviceParams[this.lang]"
      @on-cancel="deviceParamsModal = false"
    >
      <DeviceParamsPanel :lang="lang" />
      <div slot="footer">
        <Button type="primary" @click="deviceParamsModal = false">{{ langMap.close[this.lang] }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from "../../../api/index.js";
import { getItem } from '@/utils/mapUtil.js';
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import DeviceParamsPanel from './DeviceParamsPanel.vue';

const validStation = (rule, value, callback,language) => {
  if (!value && value!==0) {
    callback(new Error(langMap.stationRequired[language]));
  } else {
    callback();
  }
};

export default {
  components: {
    DeviceParamsPanel
  },
  data() {
    const _this = this;

    return {
      langMap:langMap,
      height: document.documentElement.clientHeight - 300,
      puKey: "",
      prKey: "",
      modal1: false,
      deviceParamsModal: false,
      btnLoading: false,
      saveModal: false,
      robotList: [],
      index: 1,
      total: 0,
      queryStationId: '', // 查询用站点id
      //表格
      tableLoading: false,
      code: "",
      name: "",
      type: "",
      saveForm: {
        id: "",
        productId: "",
        code: "",
        name: "",
        type: "",
        description: "",
        stationId:'', // 归属站点id
      },
      // 归属点列表
      stationList: [],
    };
  },
  computed: {
    ...mapState({
      lang: state => state.app.language 
    }),
    stationMap() {
      const _map = {};
      this.stationList.forEach(s => {
        _map[s.id] = s.name;
      });
      return _map;
    },
    col () {
      const _this = this;
      return [
        {
          title: "#",
          width: 80,
          key: "index",
          render(h, params) {
            return h("span", params.index + 1);
          }
        },
        {
          title: langMap.productId[this.lang],
          width: 120,
          key: "productId"
        },
        {
          title: langMap.serialNumberLabel[this.lang],
          width: 120,
          key: "code"
        },
        {
          title: langMap.name[this.lang],
          width: 120,
          key: "name"
        },
        {
          title: langMap.modelNumber[this.lang],
          width: 120,
          key: "type"
        },
        {
          title: langMap.belongStation[this.lang],
          width: 150,
          key: "stationId",
          render:(h, { row }) =>{
            return h('span', _this.stationMap[row.stationId])
          }
        },
        {
          title: langMap.description[this.lang],
          minWidth: 100,
          key: "description"
        },
        {
          title: langMap.createTime[this.lang],
          width: 150,
          key: "createTime",
          render(h, params) {
            var text = "";
            if (params.row.createTime) {
              text = params.row.createTime;
            } else {
              text = "-";
            }
            return h("span", text);
          }
        },
        {
          title: langMap.updateTime[this.lang],
          width: 150,
          key: "updateTime",
          render(h, params) {
            var text = "";
            if (params.row.updateTime) {
              text = params.row.updateTime;
            } else {
              text = langMap.noModification[this.lang];
            }
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          width: 340,
          align: "center",
          render: (h, params) => {
            //渲染数组
            var renderArray = [];
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.modelShow(true, params.row);
                    }
                  }
                },
                langMap.modifyInfo[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      // params.row
                      this.$Modal.confirm({
                        title: langMap.systemTip[this.lang],
                        content: langMap.confirmDeleteRobot[this.lang],
                        okText: langMap.confirm[this.lang],
                        cancelText: langMap.cancel[this.lang],
                        onOk: () => {
                          this.$Spin.show();
                          api
                            .getData(
                              "robot-server/robot/delete/" + params.row.id,
                              this
                            )
                            .then(res => {
                              if (res.state == 0) {
                                this.$Notice.error({
                                  title: langMap.tip[this.lang],
                                  desc: res.msg
                                });
                              } else {
                                this.getList();
                              }
                              this.$Spin.hide();
                            });
                        }
                      });
                    }
                  }
                },
                langMap.delete[this.lang]
              )
            );
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            if (params.row.keyFlag) {
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        this.$Spin.show();
                        api
                          .getData(
                            "robot-server/robot/get/key/" + params.row.id,
                            this
                          )
                          .then(res => {
                            if (res.state == 0) {
                              this.$Notice.error({
                                title: langMap.tip[this.lang],
                                desc: res.msg
                              });
                            } else {
                              // this.getList();
                              this.puKey = res.data.publicKey;
                              this.prKey = res.data.privateKey;
                              this.modal1 = true;
                            }
                            this.$Spin.hide();
                          });
                      }
                    }
                  },
                  langMap.viewKeyPair[this.lang]
                )
              );
            } else {
              renderArray.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "text",
                      size: "small"
                    },
                    style: {
                      padding: "1px",
                      color: "#2d8cf0"
                    },
                    on: {
                      click: () => {
                        // params.row
                        this.$Modal.confirm({
                          title: langMap.systemTip[this.lang],
                          content: langMap.confirmGenerateKey[this.lang],
                          okText: langMap.confirm[this.lang],
                          cancelText: langMap.cancel[this.lang],
                          onOk: () => {
                            this.$Spin.show();
                            api
                              .getData(
                                "robot-server/robot/gen/key/" + params.row.id,
                                this
                              )
                              .then(res => {
                                if (res.state == 0) {
                                  this.$Notice.error({
                                    title: langMap.tip[this.lang],
                                    desc: res.msg
                                  });
                                } else {
                                  this.getList();
                                }
                                this.$Spin.hide();
                              });
                          }
                        });
                      }
                    }
                  },
                  langMap.generateKeyPair[this.lang]
                )
              );
            }
            renderArray.push(
              h("Divider", {
                props: {
                  type: "vertical"
                },
                style: {
                  margin: "0 2px"
                }
              })
            );
            renderArray.push(
              h(
                "Button",
                {
                  props: {
                    type: "text"
                  },
                  style: {
                    padding: "1px",
                    color: "#2d8cf0"
                  },
                  on: {
                    click: () => {
                      this.deviceParamsModal = true;
                    }
                  }
                },
                langMap.deviceParams[this.lang]
              )
            );
            return h("div", renderArray);
          }
        }
      ]
    },
    // 表达校验
    ruleValidate(){
      return {
        productId: [
          { required: true, message: langMap.productIdRequired[this.lang], trigger: "blur" }
        ],
        code: [{ required: true, message: langMap.serialNumberRequired[this.lang], trigger: "blur" }],
        name: [{ required: true, message: langMap.nameRequired[this.lang], trigger: "blur" }],
        stationId: [{ required: true, validator:(rule, value, callback) => validStation(rule, value, callback, this.lang), trigger: 'change' }]
      }
    }
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      const _sid = `&stationId=${this.queryStationId || ''}`;
      api
        .getData(
          "robot-server/robot/list?index=" +
          this.index +
          "&code=" +
          this.code +
          "&name=" +
          this.name + _sid+
          "&type=" +
          this.type,
          this
        )
        .then(res => {
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: res.msg
            });
          } else {
            this.robotList = res.data.rows;
            this.total = res.data.total;
          }
          this.tableLoading = false;
        });
    },
    getStationList() {
      api.getData('task-server/robotStation/list/all', this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          if (res.data) {
            this.stationList = res.data || [];
          }
        }
      })
    },
    //搜索数据
    searchData() {
      this.index = 1;
      this.getList();
    },
    //分页数据
    goPageData(index) {
      this.index = index;
      this.getList();
    },
    modelShow(flag, data) {
      if (data) {
        this.saveForm = { ...data };
      } else {
        this.saveForm = {
          id: "",
          code: "",
          name: "",
          type: "",
          description: ""
        };
      }
      this.saveModal = flag;
      this.$refs["formValidate"].resetFields();
    },
    ok() {
      this.$refs["formValidate"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          api
            .postData("robot-server/robot/save", this.saveForm, this)
            .then(res => {
              this.btnLoading = false;
              if (res.state == 0) {
                this.$Notice.error({
                  title: langMap.promptFromSystem[this.lang],
                  desc: res.msg
                });
              } else {
                this.$Notice.success({
                  title: langMap.promptFromSystem[this.lang],
                  desc: langMap.operationSuccess[this.lang]
                });
                this.getList();
                this.saveModal = false;
              }
            });
        }
      });
    },
    cancel() {
      this.saveModal = false;
    },
  },
  created() {
    this.getList();
    this.getStationList();
  }
};
</script>

<style>
.device-params-modal-wrap .ivu-modal {
  top: 40px;
}

.device-params-modal-wrap .ivu-modal-content {
  background: #061422 !important;
  border: 1px solid rgba(0, 255, 255, 0.45);
  box-shadow: 0 0 24px rgba(0, 255, 255, 0.18), 0 12px 40px rgba(0, 0, 0, 0.55);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
}

.device-params-modal-wrap .ivu-modal-header {
  background: rgba(0, 30, 55, 0.95);
  border-bottom: 1px solid rgba(0, 255, 255, 0.25);
  flex-shrink: 0;
}

.device-params-modal-wrap .ivu-modal-header-inner,
.device-params-modal-wrap .ivu-modal-close .ivu-icon-ios-close {
  color: #00ffff !important;
}

.device-params-modal-wrap .ivu-modal-body {
  background: #061422;
  padding: 16px 18px;
  flex: 1 1 auto;
  max-height: calc(100vh - 200px);
  overflow-y: auto !important;
}

.device-params-modal-wrap .ivu-modal-body::-webkit-scrollbar {
  width: 6px;
}

.device-params-modal-wrap .ivu-modal-body::-webkit-scrollbar-thumb {
  background: rgba(0, 255, 255, 0.35);
  border-radius: 3px;
}

.device-params-modal-wrap .ivu-modal-footer {
  background: rgba(0, 24, 44, 0.95);
  border-top: 1px solid rgba(0, 255, 255, 0.2);
  flex-shrink: 0;
}

.device-params-modal-wrap .ivu-modal-footer .ivu-btn-primary {
  background: rgba(0, 255, 255, 0.15);
  border-color: #00ffff;
  color: #00ffff;
}

.device-params-modal-wrap .ivu-modal-footer .ivu-btn-primary:hover {
  background: rgba(0, 255, 255, 0.28);
  border-color: #00ffff;
  color: #fff;
}
</style>
